module.exports = __webpack_public_path__ + "img/overview_left_sex_female.070f7498.png";